import { Row } from 'antd';
import { styled } from 'styled-components';
import MergeTicketButton from '../../Button/MergeTicketButton';
import SplitButtonButton from '../../Button/SplitButton';
import FeesButton from './FeesButton';
import ButtonAddStaff from './ButtonAddStaff';
import ModalChooseStaff from './ButtonAddStaff/ModalChooseStaff';
import DeleteItemButton from './DeleteItemButton';
import DiscountItemButton from './DiscountItemButton';

const GroupActions = ({ v2 }: { v2?: boolean }) => {
  return (
    <GroupActionStyled>
      <div className='row-actions' style={{ display: 'none' }}>
        <DiscountItemButton />
        <DeleteItemButton />
        <FeesButton v2={v2} />
      </div>
      <div className='row-actions' style={v2 ? { display: 'none' } : {}}>
        <ButtonAddStaff />
        <MergeTicketButton />
        <SplitButtonButton />
      </div>
      <ModalChooseStaff v2={v2} />
    </GroupActionStyled>
  );
};

export default GroupActions;

const GroupActionStyled = styled(Row)`
  justify-content: flex-end;
  gap: 0.5rem;
  .row-actions {
    display: flex;
    gap: 1rem;
  }
`;